import React from 'react';
import PropTypes from 'prop-types';
import DataTable from '../shared/DataTable';

const COLUMNS = [
  { key: 'name', label: 'イベント名' },
  { key: 'event_date', label: '開催日' },
  { key: 'pv', label: 'PV' },
  { key: 'participants', label: '参加者' },
  { key: 'cvr', label: 'CVR', format: (v) => `${v}%` },
];

const PastEventComparison = ({ currentEvent, pastEvents }) => {
  const rows = [
    { name: `${currentEvent.title}（今回）`, event_date: currentEvent.event_date, pv: currentEvent.pv, participants: currentEvent.participants, cvr: currentEvent.cvr },
    ...pastEvents,
  ];

  return (
    <div className="o-dashboard__section">
      <h3 className="o-dashboard__section-title">過去イベントとの比較</h3>
      <DataTable columns={COLUMNS} rows={rows} highlightIndex={0} />
    </div>
  );
};

PastEventComparison.propTypes = {
  currentEvent: PropTypes.shape({
    title: PropTypes.string,
    pv: PropTypes.number,
    participants: PropTypes.number,
    cvr: PropTypes.number,
  }).isRequired,
  pastEvents: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      pv: PropTypes.number,
      participants: PropTypes.number,
      cvr: PropTypes.number,
    })
  ).isRequired,
};

export default PastEventComparison;
